export { UsingTermsPage as default } from '@/components/pages/Legal/UsingTerms'
